import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { User } from 'app/shared/models/user';
import { AuthService, Identity, IEntityResolver } from '@kpd/framework-ngx';
import { Resolve } from '@angular/router';
import { filter, map, take } from 'rxjs/operators';

@Injectable()
export class CurrentUserEntityResolver implements IEntityResolver<User>, Resolve<User> {
  constructor(private authService: AuthService) {}

  resolve(): Observable<User> {
    return this.authService
      .getIdentityObservable()
      .pipe(
        filter(user => !!user.upn),
        map((id: Identity) => {
          // Return a User with the upn of the Identity, actual User will be queried if needed
          const currentUser = new User();
          currentUser.upn = id.upn;
          return currentUser;
        }),
      )
      .pipe(take(1));
  }
}
